export default "__VITE_ASSET__kGy21jD2__"